import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';
import Menu from './components/Menu/Menu';
import ToDo from './components/ToDo/ToDo';
import Photo from './components/Photo/Photo';
import Holiday from './components/Holiday/Holiday';
import L4 from './components/Holiday/L4';
import ShoppingList from './components/ShoppingList/ShoppingList';
import ShoppingListEnd from './components/ShoppingListEnd/ShoppingListEnd';
import TravelsEnd from './components/TravelsEnd/TravelsEnd';
import Travels from './components/Travels/Travels';
import ToDoEnd from './components/ToDoEnd/ToDoEnd';
import OneGroup from './components/ToDo/OneGroup';
import OneGroupTasksEnd from './components/ToDoEnd/OneGroupTasksEnd'




interface IState {

}



class App extends Component<{}, IState> {
  
  render() {
    return (
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="" element={<Menu />}>
              <Route index element={<Travels />}></Route>
            </Route>
            <Route path="/Zakonczone" element={<TravelsEnd />}></Route>
            <Route path="/ToDo" element={<ToDo />}></Route>
            <Route path="/ToDo/Zakonczone" element={<ToDoEnd />}></Route>
            <Route path="/ToDo/One" element={<OneGroup />}></Route>
            <Route path="/ToDo/One/Zakonczone" element={<OneGroupTasksEnd/>}></Route>
            <Route path="/ShoppingList" element={<ShoppingList />}></Route>
            <Route path="/ShoppingList/Kupione" element={<ShoppingListEnd />}></Route>
            <Route path="/Holiday" element={<Holiday />}></Route>
            <Route path="/Holiday/L4" element={<L4 />}></Route>
            <Route path="/Photo" element={<Photo />}></Route>
          </Routes>
        </BrowserRouter>


      </div>
    );
  }
}

export default App;
